import { useSettingsAndTranslations } from '@/hooks/use-settings-and-translations'
import { getTranslationByKey, type TranslationKey } from '@/i18n'

/**
 * Custom hook for handling translations and text direction.
 */
export function useTranslate() {
  const { dexfSettings, translations } = useSettingsAndTranslations()

  /**
   * @deprecated Use css instead to handle text direction.
   * Unless you know what you're doing.
   */
  const isRTL = dexfSettings.localisation.writeDirection === 'rtl'

  const { kompis, ...sofaTranslations } = translations

  function translateString(key: TranslationKey) {
    return getTranslationByKey(key, sofaTranslations)
  }

  return { isRTL, translateString }
}
